import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';

const WeekHeaderMobile = ({ weekday, classes, localeUtils, locale }) => {
  const weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return (
    <Typography variant="overline" color="textSecondary" className={classes.week}>
      <div title={weekdayName}>
        {weekday === 0 || weekday === 6 ? weekdayName.slice(0, 3) : `${weekday + 1} ͣ`}
      </div>
    </Typography>
  );
};

WeekHeaderMobile.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  localeUtils: PropTypes.object.isRequired,
  weekday: PropTypes.number.isRequired,
};

const styles = () => ({
  week: {
    display: 'table-cell',
    textAlign: 'center',
  },
});

export default withStyles(styles)(WeekHeaderMobile);
